import { useDashboardAudience } from './dashboardAudience'
import { useSearchParams } from 'react-router-dom'
import { portalSpendCategories } from './portalSpend.types'

const sorts = ['issued:desc', 'issued:asc', 'amount:desc', 'amount:asc']
export function portalSpendParams(source: URLSearchParams, csv = false) {
  const params = new URLSearchParams()
  if (source.get('q')) params.set('q', source.get('q')!)
  for (const [key, allowed] of [
    ['categories', portalSpendCategories],
    ['status', ['paid', 'unpaid']],
  ] as const) {
    const values = (source.get(key) ?? '')
      .split(',')
      .filter((value) => (allowed as readonly string[]).includes(value))
    if (values.length) params.set(key, [...new Set(values)].join(','))
  }
  const sort = source.get('sort') ?? 'issued:desc'
  params.set('sort', sorts.includes(sort) ? sort : 'issued:desc')
  if (!csv && source.get('cursor')) params.set('cursor', source.get('cursor')!)
  return params
}
export function usePortalSpendState(organizationId: number) {
  const [params, setParams] = useSearchParams()
  const filtered = portalSpendParams(params)
  const base = `${useDashboardAudience(organizationId).base}/spend`
  const change = (key: string, value: string) => {
    const next = new URLSearchParams(params)
    next.delete('cursor')
    if (value) next.set(key, value)
    else next.delete(key)
    setParams(next)
  }
  const clear = () => {
    const next = new URLSearchParams(params)
    for (const key of ['q', 'categories', 'status', 'cursor']) next.delete(key)
    setParams(next)
  }
  return {
    params: filtered,
    change,
    clear,
    path: `${base}?${filtered}`,
    csvPath: `${base}.csv?${portalSpendParams(params, true)}`,
  }
}
